import { __extends } from "tslib";
import { ErrorBase } from './ErrorBase';
/**
 * AbstractMethodError is thrown when an abstract method is called. The method in question should be overridden
 * by a concrete subclass.
 */
var ArgumentError = /** @class */ (function (_super) {
    __extends(ArgumentError, _super);
    /**
     * Create a new ArgumentError.
     *
     * @param message An optional message to override the default error message.
     * @param id The id of the error.
     */
    function ArgumentError(message, id) {
        if (message === void 0) { message = null; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message || 'ArgumentError', id) || this;
    }
    return ArgumentError;
}(ErrorBase));
export { ArgumentError };
